


























































































































import { Vue, Component } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { SETTINGS_UPDATE_PREFERENCE } from '@/store/settings/constants'
import { Preference } from '@/store/settings/types'

import SettingsHeader from '../components/SettingsHeader.vue'
import SettingsSection from '../components/SettingsSection.vue'
import SettingsRow from '../components/SettingsRow.vue'

/* eslint-disable indent */
@Component({
    name: 'notifications-panel',
    components: { SettingsHeader, SettingsSection, SettingsRow }
})
/* eslint-enable indent */
export default class NotificationsPanel extends Vue {
    @Getter
    preference!: (type: string, key: string) => any

    @Action(SETTINGS_UPDATE_PREFERENCE)
    updatePreferenceAction!: (pref: Preference) => Promise<void>

    async updatePreference(type: string, key: string, value: any): Promise<void> {
        await this.updatePreferenceAction({ type, key, value })
        this.$success({ text: 'Preference saved' })
    }

    updateAllEmail(value: boolean): void {
        try {
            this.updatePreference('email', 'send_share', value)
            this.updatePreference('email', 'send_shared_edit', value)
            this.updatePreference('email', 'send_other_edit', value)
        } catch (err) {
            this.$error({ text: err })
        }
    }

    updateAllPush(value: boolean): void {
        try {
            this.updatePreference('push', 'send_share', value)
            this.updatePreference('push', 'send_shared_edit', value)
            this.updatePreference('push', 'send_other_edit', value)
        } catch (err) {
            this.$error({ text: err })
        }
    }

    get allEmail(): boolean {
        return this.preference('email', 'send_share')
            && this.preference('email', 'send_shared_edit')
            && this.preference('email', 'send_other_edit')
    }

    get allPush(): boolean {
        return this.preference('push', 'send_share')
            && this.preference('push', 'send_shared_edit')
            && this.preference('push', 'send_other_edit')
    }
}
